var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center my-3"},[_c('hr',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('span',{staticClass:"mx-2 text-black"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('hr',{staticClass:"flex-grow-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }